import { Link, NavLink } from "react-router-dom";
import logoUrl from "../../assets/siimply-logo-v2.png"; // adjust if path differs

const tabs = [
  { to: "/simulator", label: "Trading Simulator" },
  { to: "/charts", label: "Charts" },
  { to: "/about", label: "About" },
];

export default function NavBar() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-white/10 bg-background/70 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      {/* increased nav height */}
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-4">
        {/* Brand acts as Home */}
        <Link
          to="/"
          aria-label="Siimply Home"
          className="group inline-flex items-center rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <img
            src={logoUrl}
            alt="Siimply"
            className="block h-20 w-auto border-0 transition-transform duration-150 group-hover:scale-[1.04]"
            decoding="async"
            loading="eager"
          />
        </Link>

        {/* Navigation Tabs */}
        <nav className="flex items-center gap-3 text-base">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                [
                  "px-4 py-2 rounded-xl transition-colors",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                  isActive
                    ? "bg-primary/15 text-primary"
                    : "text-foreground/80 hover:text-foreground hover:bg-foreground/5",
                ].join(" ")
              }
              end
            >
              {t.label}
            </NavLink>
          ))}
        </nav>

        {/* Spacer keeps right alignment */}
        <div className="w-[64px]" />
      </div>
    </header>
  );
}
